import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';

export class AerosolShutdownMainDto extends InspectionCase {
  hubLocation?: InspectionValueCase;
  hubMadeFrom?: InspectionValueCase;
  hubModel?: InspectionValueCase;
  detectionSystemTestedBy?: InspectionValueCase;
  protectedAreas?: InspectionValueCase;
  siteRiskLevel?: InspectionValueCase;
}

export class AerosolShutdownMain extends AerosolShutdownMainDto {
  constructor(data: AerosolShutdownMainDto = { title: 'כללי' }) {
    super(data);
    this.hubLocation = new InspectionValueCase({
      ...data.hubLocation,
      title: 'מיקום רכזת הגילוי'
    });
    this.hubMadeFrom = new InspectionValueCase({
      ...data.hubMadeFrom,
      title: 'רכזת גילוי תוצרת'
    });
    this.hubModel = new InspectionValueCase({
      ...data.hubModel,
      title: 'דגם הרכזת'
    });
    this.detectionSystemTestedBy = new InspectionValueCase({
      ...data.detectionSystemTestedBy,
      title: `מערכת הגילוי לפי ת"י 1220 חלק 3 , נבדקה ע"י`
    });
    this.protectedAreas = new InspectionValueCase({
      ...data.protectedAreas,
      title: 'האזורים המוגנים'
    });
    this.siteRiskLevel = new InspectionValueCase({
      ...data.siteRiskLevel,
      title: 'האתר מסווג ברמת סיכון'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.hubLocation.isApplicable || this.hubLocation.isPassed) &&
        (!this.hubMadeFrom.isApplicable || this.hubMadeFrom.isPassed) &&
        (!this.hubModel.isApplicable || this.hubModel.isPassed) &&
        (!this.detectionSystemTestedBy.isApplicable ||
          this.detectionSystemTestedBy.isPassed) &&
        (!this.protectedAreas.isApplicable || this.protectedAreas.isPassed) &&
        (!this.siteRiskLevel.isApplicable || this.siteRiskLevel.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.hubLocation.getNotes(),
      ...this.hubMadeFrom.getNotes(),
      ...this.hubModel.getNotes(),
      ...this.detectionSystemTestedBy.getNotes(),
      ...this.protectedAreas.getNotes(),
      ...this.siteRiskLevel.getNotes()
    ];
  }
}
